import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import Alert from './Alert';
import close from '../Asset/close.svg';
import { Link } from 'react-router-dom';
import Table from './tables/godrejTable';
import { Modal, Form } from 'react-bootstrap';
import { getUserInfo } from './functions/userInfo';
import SessionFun from './functions/sessionFun';
import {environment} from './functions/environment';

function Godrej_User_List() {
    let userObj = getUserInfo();
    const filRef = useRef(null);
    let [sessOut, setSessOut] = useState(false);
    let [file, setFile] = useState(null);
    let [fileMsg, setFileMsg] = useState("");
    const [show, setShow] = useState(false);
    const [fileShow, setFileshow] = useState(false);
    const [filterShow, setFiltershow] = useState(false);
    let [filter, setFilter] = useState({
        toDate: "",
        fromDate: "",
    });
    let [apiMsg, setApiMsg] = useState({
        msg: "",
        status: false,
        link: ""
    });
    const handleClose = () => {
        setShow(false);
        setErrorMsg({});
        setCurrentUser({
            firstName: "",
            lastName: "",
            emailID: "",
            areaID: "",
            branchID: "",
            personaID: "",
            isActive: "",
            PhoneNumber: "",
            businessFunction: ""
        })
    };
    const fileHandelOpen = () => {
        setFileshow(true);
    };
    const fileHandelClose = () => {
        setFileshow(false);
        filRef.current.value = "";
        setFileMsg("");
        setFile(null);
    };
    const filterOpen = () => {
        setFiltershow(true);
    }
    const filterClose = () => {
        setFilter({
            toDate: "",
            fromDate: "",
        });
        setFiltershow(false);
        setFilErrorMsg({});
    }
    function clearFilter() {
        filterClose();
        getGodrejUserList(userObj.accountID, "reset");
    }
    let [alert, setAlert] = useState({
        msg: "",
        status: false
    });
    let [users, setUsers] = useState([]);
    let [area, setArea] = useState([]);
    let [branch, setBranch] = useState([]);
    let [persona, setPersona] = useState([]);
    let [currentUser, setCurrentUser] = useState({
        firstName: "",
        lastName: "",
        emailID: "",
        areaID: "",
        branchID: "",
        personaID: "",
        isActive: true,
        PhoneNumber: "",
        businessFunction: ""
    });
    let [errorMsg, setErrorMsg] = useState({});
    let [filErrorMsg, setFilErrorMsg] = useState({});

    useEffect(() => {
        getGodrejUserList(userObj.accountID);
        getArea();
        getPersona();
    }, [])

    function getFilterData(e) {
        setFilter({ ...filter, [e.target.name]: e.target.value });
    }
    function getfilterValue() {
        let error = {};
        if (filter.fromDate == "") {
            error.startDate = "This field is required";
        }
        if (filter.toDate == "") {
            error.endDate = "This field is required";
        }
        setFilErrorMsg(error);
        if (Object.keys(error).length == 0) {
            getGodrejUserList(userObj.accountID);
            // console.log("Data:", filter);
            setFiltershow(false);
        }
    }
    
    function getGodrejUserList(accID, type) {
        let req = {};
        if (type == "reset") {
            req = {
                "accountID": accID,
                "userType": "business_user",
                "startDate": "",
                "endDate": ""
            }
        }
        else {
            req = {
                "accountID": accID,
                "userType": "business_user",
                "startDate": filter.fromDate,
                "endDate": filter.toDate
            }
        }

        fetch(environment.baseUrl + "getUserByAccID?", {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify(req)
        })
            .then((apiRes) => {
                apiRes.json().then((resp) => {
                    //console.log("getUserByAccID:", resp)
                    let temp = [];
                    resp.data.result.forEach(element => {
                        let t = element;
                        t.usersName = element.firstName + " " + element.lastName;
                        temp.push(t);
                    });
                    setUsers(temp);
                })
            })
    }

    function getArea() {
        fetch(environment.baseUrl + 'getAllAreas', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            }
        }).then((res) => {
            res.json().then((resp) => {
                if (resp.code == 200) {
                    setArea(resp.data.result);
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setArea([]);
                }
            })
        })
    }

    function getBranch(id) {
        fetch(environment.baseUrl + 'getBranchByArea', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                "areaID": id
            })
        }).then((res) => {
            res.json().then((resp) => {
                if (resp.code == 200) {
                    setBranch(resp.data.result);
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setBranch([]);
                }
            })
        })
    }

    function getPersona() {
        fetch(environment.baseUrl + 'getPersona', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            }
        }).then((res) => {
            res.json().then((resp) => {
                if (resp.code == 200) {
                    setPersona(resp.data.result);
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
                else {
                    setPersona([]);
                }
            })
        })
    }
    function getUserFormData(e) {
        if (e.target.name == "areaID" || e.target.name == "branchID" || e.target.name == "personaID") {
            setCurrentUser({ ...currentUser, [e.target.name]: e.target.value == "" ? "" : parseInt(e.target.value) });
            if (e.target.name == "areaID" && e.target.value != "") {
                setCurrentUser({ ...currentUser, branchID: "", [e.target.name]: e.target.value == "" ? "" : parseInt(e.target.value) });
                setBranch([]);
                getBranch(e.target.value);
            }
        }
        else if (e.target.name == "isActive") {
            setCurrentUser({ ...currentUser, [e.target.name]: e.target.value });
        }
        else {
            setCurrentUser({ ...currentUser, [e.target.name]: e.target.value });
        }
    }
    const editGodrejUser = useCallback((obj) => {
        getBranch(obj.areaID);
        setCurrentUser(obj);
        setShow(true);
    }, [])
    function validateUserForm() {
        const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let error = {};
        const phoneRegex = /^[0]?[6789]\d{9}$/;

        if (currentUser.areaID == "") {
            error.areaID = "This field is required";
        }
        if (currentUser.firstName == "") {
            error.firstName = "This field is required";
        }
        if (currentUser.lastName == "") {
            error.lastName = "This field is required";
        }
        if (currentUser.personaID == "") {
            error.personaID = "This field is required";
        }
        if (currentUser.emailID == "") {
            error.emailID = "This field is required";
        }
        if (currentUser.PhoneNumber) {
            if (currentUser.PhoneNumber != "" && isNaN(currentUser.PhoneNumber)) {
                error.PhoneNumber = "Mobile number must be in digit"
            }
            else if (currentUser.PhoneNumber != "" && currentUser.PhoneNumber.length > 10 || currentUser.PhoneNumber != "" && currentUser.PhoneNumber.length < 10) {
                error.PhoneNumber = "Enter valid mobile number"
            }
        }

        setErrorMsg(error);
        if (Object.keys(error).length == 0) {
            updateGodrejUser();
        }
    }
    function updateGodrejUser() {
        fetch(environment.baseUrl + "updateUser", {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify({
                userID: currentUser.userID,
                firstName: currentUser.firstName,
                lastName: currentUser.lastName,
                emailID: currentUser.emailID,
                areaID: currentUser.areaID,
                branchID: currentUser.branchID,
                personaID: currentUser.personaID,
                isActive: currentUser.isActive,
                phoneNumber: currentUser.PhoneNumber,
            })
        }).then((apiRes) => {
            apiRes.json().then((resp) => {
                handleClose();
                setAlert({
                    msg: resp.msg,
                    status: true
                });
                if (resp.code == 200) {
                    getGodrejUserList(userObj.accountID);
                }
                else if (resp.code == 401) {
                    setSessOut(true);
                }
            })
        })

    }
    function getSelectedFile(e) {
        setFileMsg("");
        let nameArr = (e.target.files[0].name).split(".");
        if (nameArr.length == 2 && nameArr[1] == "xlsx" && nameArr[0] != "") {
            setFile(e.target.files[0]);
        }
        else{
            setFile(null);
            filRef.current.value = "";
            setFileMsg("Only Excel file allowed.");
        }
    }
    function uploadFile() {
        // //for just file upload
        // if (file) {
        //     let formData = new FormData();
        //     formData.append("file", file);

        //     fetch(environment.baseUrl + "importGodrejUser", {
        //         method: "POST",
        //         headers: {
        //             "Authorization": "Bearer " + userObj.token
        //         },
        //         body: formData
        //     }).then((result) => {
        //         result.json().then((res) => {
        //             if (result.status == 200) {
        //                 fileHandelClose();
        //                 getGodrejUserList(userObj.accountID);
        //             }
        //             else if (res.code == 401) {
        //                 setSessOut(true);
        //             }

        //             setAlert({
        //                 msg: res.message,
        //                 status: true
        //             });

        //         })
        //     });
        // }
        // else {
        //     setFileMsg("Please select file first");
        // }

        //for file upload with failed report
        if (file) {
            let formData = new FormData();
            formData.append("file", file);

            fetch(environment.baseUrl + "godrejuserfailedreport?", {
                method: "POST",
                headers: {
                    "Authorization": "Bearer " + userObj.token
                },
                body: formData
            }).then((result) => {
                result.json().then((res) => {
                    if (result.status == 200) {
                        fileHandelClose();
                        getGodrejUserList(userObj.accountID);
                    }
                    else if (res.code == 401) {
                        setSessOut(true);
                    }
                    setFileshow(false);
                    setApiMsg({
                        msg: res.message,
                        status: true,
                        link: res.data ? res.data : null
                        // link: res.downloadLink ? res.downloadLink : null
                    })
                })
            });
        }
        else {
            setFileMsg("Please select file first");
        }
    }

    const columns = useMemo(
        () => [
            {
                Header: 'Business Function ',
                accessor: 'businessFunction', 
            },
            {
                Header: 'Area Code',
                accessor: 'areaName',
            },
            {
                Header: 'Branch',
                accessor: 'branchName',
            },
            {
                Header: 'User Name ',
                accessor: 'usersName',
            },
            {
                Header: 'Persona ',
                accessor: 'personaName',
            },
            {
                Header: 'Email ID ',
                accessor: 'emailID',
            },
            {
                Header: 'Mobile No. ',
                accessor: 'PhoneNumber',
            },
            {
                Header: 'Update Date ',
                accessor: 'updatedDateTime',
            },
            {
                Header: 'Action ',
                accessor: 'action',
            }
        ],
        []
    )
    function closeModal() {
        setApiMsg({ msg: "", status: false, link: "" });
    }
    function triggerFun(){
        var blob = base64toBlob(apiMsg.link, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
        downloadBlob(blob, 'Failed_Report.xlsx');
    }
    function base64toBlob(base64Data, contentType) {
        var byteCharacters = atob(base64Data);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    }

    function downloadBlob(blob, fileName) {
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
    }

    return (
        <div className='main-container'>
            <Alert obj={alert} />
            <SessionFun show={sessOut}></SessionFun>
            <h4 className='main-heading'>Godrej User List</h4>
            <p className='short-link'><Link to='/'>Home&nbsp;
                <i className='fa fa-angle-right'></i></Link>&nbsp;Godrej User List
            </p>

            <div className="row">
                <div className="col-sm-12 card-box-block">
                    <Table columns={columns} data={users}
                        editFun={editGodrejUser}
                        openFun={fileHandelOpen}
                        filterFun={filterOpen} />
                </div>
            </div>

            <Modal show={show} onHide={handleClose} centered backdrop="static" size="lg">
                <Modal.Header>
                    <Modal.Title> Update Godrej User</Modal.Title>
                    <button onClick={handleClose} type="button" className="close">
                        <img src={close} alt="" />
                    </button>
                </Modal.Header>
                <Modal.Body className=' logout-box'>
                    <div className='row'>
                        <div className="col-sm-4">
                            <Form.Group className="mb-3" >
                                <Form.Label>Business Function</Form.Label><span className='red'>*</span>
                                <Form.Control type="text" className="textbox-back" name='businessFunction' value={currentUser.businessFunction} readOnly placeholder="Enter Business Function" />
                            </Form.Group>
                        </div>
                        <div className="col-sm-4">
                            <Form.Group className="mb-3" >
                                <Form.Label>Area Code</Form.Label><span className='red'>*</span>
                                <Form.Select className="textbox-back" name='areaID' value={currentUser.areaID} onChange={getUserFormData} placeholder="Enter Area">
                                    <option value="">Select</option>
                                    {
                                        area.map((item, index) =>
                                            <option key={index} value={item.areaID}>{item.areaName}</option>
                                        )
                                    }
                                </Form.Select>
                                <small className='red'>{errorMsg.areaID}</small>
                            </Form.Group>
                        </div>
                        <div className="col-sm-4">
                            <Form.Group className="mb-3" >
                                <Form.Label>Branch</Form.Label><span className='red'>*</span>
                                <Form.Select className="textbox-back" name='branchID' value={currentUser.branchID} onChange={getUserFormData} placeholder="Enter Branch">
                                    <option value="">Select</option>
                                    {
                                        branch.map((item, index) =>
                                            <option key={index} value={item.branchID}>{item.branchName}</option>
                                        )
                                    }
                                </Form.Select>
                                <small className='red'>{errorMsg.branchID}</small>
                            </Form.Group>
                        </div>

                        <div className="col-sm-4">
                            <Form.Group className="mb-4" >
                                <Form.Label>First Name</Form.Label><span className='red'>*</span>
                                <Form.Control type="text" className="textbox-back" name="firstName" value={currentUser.firstName} onChange={getUserFormData} placeholder="Enter First Name" />
                                <small className='red'>{errorMsg.firstName}</small>
                            </Form.Group>
                        </div>
                        <div className="col-sm-4">
                            <Form.Group className="mb-4" >
                                <Form.Label>Last Name</Form.Label><span className='red'>*</span>
                                <Form.Control type="text" className="textbox-back" name='lastName' value={currentUser.lastName} onChange={getUserFormData} placeholder="Enter Last Name" />
                                <small className='red'>{errorMsg.lastName}</small>
                            </Form.Group>
                        </div>
                        <div className="col-sm-4">
                            <Form.Group className="mb-4" >
                                <Form.Label>Persona</Form.Label><span className='red'>*</span>
                                <Form.Select className="textbox-back" name='personaID' value={currentUser.personaID} onChange={getUserFormData} placeholder="Enter Persona">
                                    <option value="">Select</option>
                                    {
                                        persona.map((item, index) =>
                                            <option key={index} value={item.personaID}>{item.personaName}</option>
                                        )
                                    }
                                </Form.Select>
                                <small className='red'>{errorMsg.personaID}</small>
                            </Form.Group>
                        </div>

                        <div className="col-sm-4">
                            <Form.Group className="mb-4" >
                                <Form.Label>Email ID</Form.Label><span className='red'>*</span>
                                <Form.Control type="text" className="textbox-back" name='emailID' value={currentUser.emailID} onChange={getUserFormData} placeholder="Enter Email ID" readOnly />
                                <small className='red'>{errorMsg.emailID}</small>
                            </Form.Group>
                        </div>
                        <div className="col-sm-4">
                            <Form.Group className="mb-4" >
                                <Form.Label>Mobile No.</Form.Label>
                                <Form.Control type="text" className="textbox-back" name='PhoneNumber' value={currentUser.PhoneNumber ? currentUser.PhoneNumber : ""} onChange={getUserFormData} placeholder="Enter Mobile No." />
                                <small className='red'>{errorMsg.PhoneNumber}</small>
                            </Form.Group>
                        </div>
                        <div className="col-sm-4">
                            <Form.Group className="mb-4" >
                                <Form.Label> Status</Form.Label><span className='red'>*</span>
                                <Form.Select className="textbox-back" name='isActive' value={String(currentUser.isActive)} onChange={getUserFormData}>
                                    <option value="true">Active</option>
                                    <option value="false">Inactive</option>
                                </Form.Select>
                            </Form.Group>
                        </div>

                    </div>

                    <div className="row text-center mt-4">
                        <div className="col-sm-6">
                            <button className="btn btn-outline-secondary lo-btn float-end" onClick={handleClose}>
                                Cancel
                            </button>
                        </div>
                        <div className="col-sm-6">
                            <button className="btn add-btn btn-light lo-btn confirm-btn float-start" onClick={validateUserForm}>
                                Update
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={fileShow} onHide={fileHandelClose} centered backdrop="static">
                <Modal.Header>
                    <Modal.Title>Import Godrej User List</Modal.Title>
                    <button onClick={fileHandelClose} type="button" className="close">
                        <img src={close} alt="" />
                    </button>
                </Modal.Header>
                <Modal.Body className='logout-box'>
                    <div className="row">
                        <Form.Group className="mb-1" >
                            <Form.Control
                                type="file"
                                name="file"
                                id="file"
                                ref={filRef}
                                onChange={getSelectedFile}
                                accept=".xlsx,.csv"
                            />
                        </Form.Group>
                        <small><b>Note: Please upload Godrej User List in .xlsx format</b></small>
                        <small className='red'>{fileMsg}</small>
                    </div>
                    <div className="row text-center mt-3">
                        <div className="col-sm-6">
                            <button className="btn btn-outline-secondary lo-btn float-end" onClick={fileHandelClose}>
                                Cancel
                            </button>
                        </div>
                        <div className="col-sm-6">
                            <button className="btn btn-light lo-btn confirm-btn float-start" onClick={uploadFile}>
                                Upload
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={filterShow} onHide={filterClose} centered backdrop="static">
                <Modal.Header>
                    <Modal.Title>Filter</Modal.Title>
                    <button onClick={filterClose} type="button" className="close">
                        <img src={close} alt="" />
                    </button>
                </Modal.Header>
                <Modal.Body className=' logout-box'>
                    <div className='row'>
                        <div className='col-sm-6'>
                            <Form.Group className="mb-2" >
                                <label>From Date</label>
                                <Form.Control type='date' name='fromDate' value={filter.fromDate}
                                    className="textbox-back" onChange={getFilterData} />
                            </Form.Group>
                            <small className='red'>{filErrorMsg.startDate}</small>
                        </div>
                        <div className='col-sm-6'>
                            <Form.Group className="mb-2" >
                                <label>To Date</label>
                                <Form.Control type='date' name='toDate' value={filter.toDate} min={filter.fromDate}
                                    className="textbox-back" onChange={getFilterData} />
                            </Form.Group>
                            <small className='red'>{filErrorMsg.endDate}</small>
                        </div>
                    </div>

                    <div className="row text-center mt-4">
                        <div className="col-sm-6">
                            <button className="btn btn-outline-secondary lo-btn float-end" onClick={clearFilter}>
                                Cancel
                            </button>
                        </div>
                        <div className="col-sm-6">
                            <button className="add-btn btn-light lo-btn confirm-btn float-start" onClick={getfilterValue}>
                                Apply
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={apiMsg.status} onHide={closeModal} centered backdrop="static" size="sm">
                <Modal.Header>
                    <Modal.Title>Message</Modal.Title>
                    <button onClick={closeModal} type="button" className="close">
                        <img src={close} alt="" />
                    </button>
                </Modal.Header>
                <Modal.Body className='text-center logout-box'>
                    <p className='mb-0'><b>{apiMsg.msg}</b></p>
                    {
                        apiMsg.link ?
                            <button className='btn btn-link' onClick={triggerFun}>Failed Report</button>
                            // <a href={apiMsg.link} target="_blank">Failed Report</a>
                            : null
                    }
                </Modal.Body>
            </Modal>
        </div>

        
    )
}

export default Godrej_User_List
